import { render, staticRenderFns } from "./DateCompletedRenderer.vue?vue&type=template&id=4c9d66d8&"
import script from "./DateCompletedRenderer.vue?vue&type=script&lang=ts&"
export * from "./DateCompletedRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports